import "./WorkshopSpace.module.css";
import Header from "@/reusable_sections/Header";
import CoursesOverview from "./sections/CoursesOverview";
import CelebrationGallery from "./sections/CelebrationGallery";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function WorkshopSpacePage() {
  return <div>
      <Header />
      <CoursesOverview />
      <CelebrationGallery />
      <GetInTouch />
      <Footer />
    </div>;
}